<template>
  <div class="dx-alert">
    <div :class="alertClasses">
      <slot></slot>
      <span
        class="close-alert"
        @click="closeAlert" @keyDown="closeAlert">
        <dx-icon :icon="['fas', 'close']" />
      </span>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { propValidationService } from '../functions';

library.add(faClose);

const THEME_TYPES = [
  { key: 'success' },
  { key: 'warning' },
  { key: 'error' },
];

export default {
  name: 'dx-alert',
  props: {
    theme: {
      type: String,
      default: 'success',
      validator: propValidationService.buildValidator({
        validValues: THEME_TYPES.map((theme) => theme.key),
        errorMessage: 'You should inform a valid theme',
      }),
    },
  },
  computed: {
    alertClasses() {
      return {
        [this.theme]: true,
      };
    },
  },
  methods: {
    closeAlert() {
      this.$el.style.display = 'none';
    },
  },
};
</script>
<style scoped lang="scss">
  .dx-alert {
    padding: var(--dx-space-size--xs);

   div {
    padding: var(--dx-space-size--xs) var(--dx-space-size--sm);
    border-radius: 3px;

    &.success {
      background-color: var(--dx-color--green-light);
      color: var(--dx-color--green-dark);
    }

    &.warning {
      background-color: var(--dx-color--yellow-light);
      color: var(--dx-color--yellow-dark);
    }

    &.error {
      background-color: var(--dx-color--red-light);
      color: var(--dx-color--red-dark);
    }

    .close-alert {
      float: right;
      cursor: pointer;
      padding: 6px 8px;
      margin: -6px;
    }
   }
  }
</style>
